<template>
  <section id="infinite-dtb">
    <div class="title">
      <div class="dtb-title">
        <!-- <span class="iconfont">&#xe616;</span> -->
        <a :href="$i18n.path('live')">{{ $t('infinite-dtb.title') }}</a>
        <span class="dtbGif"></span>
      </div>
      <a class="more iconfont" :href="$i18n.path('live')">{{ $t('infinite-dtb.more') }} ></a>
    </div>
    <div v-show="isHidden" class="InfoDetail">
      <ul>
        <li v-for="(item, index) in purDtbList" :key="index">
          <a :href="$i18n.path(`live/${item.id}`)" target="_blank">{{item.title}}</a>
        </li>
      </ul>
    </div>
    <div id="infinite-overfolow-box" v-show="!isHidden">
      <ul id="infinite-content">
        <li class="time">
          <span class="clock iconfont">&#xe605;</span>
          {{nowTime}}
        </li>
        <li :class="['dtb',item.isnewDate?'newDay':'']" v-for="(item,index) in finalDtbList" :key="index">
          <div class="time-line" v-if="item.isnewDate">
            <span class="clock iconfont">&#xe605;</span>
            {{item.createTimeDate}}
          </div>
          <div class="content-box">
            <span>{{item.createTimeShow}}</span>
            <a :href="$i18n.path(`live`)" :class="item.level === 1 ?'level-1':''">{{item.title}}</a>
          </div>
        </li>
      </ul>
    </div>
  </section>
</template>
<script>
import * as api from "~/api/index";
import initTime from "~/plugins/initTime";
export default {
  name: "infiniteDtb",
  data () {
    return {
      isHidden: true,
      nowTime: "",
      finalDtbList: [],
      pureDtbList: [],
      liveId: null,
      newDtbList: [],
      isSeending: false,
      getTimeInterval: null,
      interval: null
    };
  },
  methods: {
    initTime (t) {
      return initTime(t);
    },
    getTime () {
      this.nowTime = initTime().format("Y-M-D H:m:s");
    },
    showDtb (t) {
      let liveId = t || "";
      let queryLimit = {
        liveChannelId: 'all', limit: 20
      }
      if (t) {
        queryLimit = { liveChannelId: 'all', liveId: liveId, limit: 20 }
      }
      this.$axios(
        api.infidtbList(queryLimit)
      ).then(res => {
        this.newDtbList = res.result;
        if (!t && !this.pureDtbList[0]) {
          this.pureDtbList = res.result;
          this.liveId = res.result[res.result.length - 1].id;
          this.processDtb();
        } else if (
          !t &&
          this.pureDtbList[0] &&
          this.pureDtbList[0].id < this.newDtbList[0].id
        ) {
          this.newDtbList = this.newDtbList.reverse();
          for (let i = 0; i < this.newDtbList.length; i++) {
            if (this.pureDtbList[0].id < this.newDtbList[i].id) {
              this.pureDtbList.unshift(this.newDtbList[i]);
            }
          }
          this.processDtb();
        } else if (t) {
          this.pureDtbList.push(...res.result);
          this.liveId = res.result[res.result.length - 1].id;
          this.processDtb();
        }
      });
    },

    processDtb () {
      let pureDtbList = [...this.pureDtbList];
      let nowTime = parseInt(new Date().getTime() / 1000);
      pureDtbList.forEach((item, index) => {
        item.isnewDate = item.isnewDate || false;
        item.createTimeShow = initTime(item.createTime * 1000).format("H:m ");
        item.createTimeDate = initTime(item.createTime * 1000).format("Y-M-D");

        if (index < pureDtbList.length - 1) {
          if (
            initTime(item.createTime * 1000).format("MD") !=
            initTime(pureDtbList[+index + 1].createTime * 1000).format("MD")
          ) {
            pureDtbList[index + 1].isnewDate = true;
          }
        }
      });
      this.finalDtbList = [...pureDtbList];
      this.isSeending = false;
    }
  },
  mounted () {
    clearInterval(this.getTimeInterval);
    clearInterval(this.interval);
    this.isHidden = false;
    this.getTime();
    this.getTimeInterval = setInterval(() => {
      this.getTime();
    }, 1000);
    this.showDtb();
    this.interval = setInterval(() => {
      this.showDtb();
    }, 120000);

    let dtbBox = document.getElementById("infinite-overfolow-box");
    let dtbCt = document.getElementById("infinite-content");
    let that = this;
    let infiniteDtb = () => {
      let scrollTop = dtbBox.scrollTop || dtbBox.scrollTop;
      let clientHeight = dtbCt.offsetHeight;
      if (parseInt(scrollTop) + 386 > parseInt(clientHeight) - 100) {
        if (!that.isSeending) {
          that.isSeending = true;
          that.showDtb(that.liveId);
        }
      }
    };
    // infiniteDtb();
    dtbBox.addEventListener("scroll", infiniteDtb);
  },
  beforeDestroy () {
    clearInterval(this.getTimeInterval);
    clearInterval(this.interval);
    this.getTimeInterval = null;
    this.interval = null;
  },
  computed: {
    purDtbList () {
      return this.$store.state.purDtbList;
    }
  }
};
</script>
<style lang="less" scoped>
#infinite-dtb {
  height: 446px;
  width: 328px;
  padding: 0;
  margin: 0;
  background-color: #fff;
  position: relative;
  overflow: hidden;

  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 60px;

    .more {
      font-size: 12px;
      font-weight: 400;
      color: #999999;
      margin-right: 20px;
    }

    .dtb-title {
      font-size: 14px;
      clear: both;
      padding-left: 20px;
      height: 19px;
      font-weight: bolder;
      background-color: #fff;
      display: flex;
      align-items: center;
      .iconfont {
        color: #478cf3;
        font-weight: 100;
        font-size: 20px;
      }
      a {
        line-height: 24px;
        color: #222222;
        font-size: 16px;
      }

      .dtbGif {
        margin-left: 10px;
        width: 40px;
        height: 40px;
        display: inline-block;
        background: url("https://cdn.gelonghui.com/static/web/dtb.gif") 0 0
          no-repeat;
        background-size: 100% 100%;
      }
    }
  }

  .InfoDetail {
    position: absolute;
    top: 110%;
    left: 0;
    background-color: #fff;
  }

  #infinite-overfolow-box {
    overflow-y: scroll;
    width: 100%;
    height: 386px;

    &::-webkit-scrollbar {
      transition: all ease-out 200ms;
      width: 4px;
      height: 4px;
    }

    &::-webkit-scrollbar-track {
      background: #f6f6f6;
      border-radius: 5px;
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(170, 170, 170, 0);
      border-radius: 5px;
      transition: all 4s ease;
    }

    &:hover::-webkit-scrollbar-thumb {
      background: #b1b1b1;
    }

    &::-webkit-scrollbar-corner {
      background: #f6f6f6;
    }

    .time,
    .time-line {
      width: 100%;
      padding: 0 22px;
      height: 39px;
      line-height: 39px;
      background-color: #fafcff;
      color: #222222;
      font-size: 14px;
      font-weight: 400;
    }

    .time-line {
      position: relative;
      width: 324px;
      left: -22px;
    }

    .clock {
      font-size: 12px;
      color: #999999;
      margin-right: 5px;
    }

    .dtb {
      margin: 0 22px;
      border-top: 1px dashed rgb(218, 218, 218);
      position: relative;

      &:nth-child(2),
      .dtb.newDay {
        border-top: none;
      }
    }

    .content-box {
      display: flex;
      padding: 20px 0px;
      padding-top: 20px;

      span {
        font-size: 12px;
        // font-family: MicrosoftYaHei;
        font-weight: 400;
        line-height: 1.5em;
        color: #3278d2;
      }

      a {
        line-height: 1.5em;
        display: block;
        text-decoration: none;
        font-size: 14px;
        font-weight: 400;
        color: rgba(34, 34, 34, 1);
        text-align: left;
        padding-left: 10px;
      }

      a.level-1 {
        color: red;
      }
    }
  }
}
</style>
